import { motion } from 'motion/react';
import className from 'classnames/bind';
import { Button, HeadlineAnim } from '@components';
import { getHighlightMarkup, getLinkData } from '@/core/utils';

import styles from './SectionHeader.module.scss';
const cx = className.bind(styles);

interface SectionHeaderProps {
  largeTitle?: boolean;
  eyebrow?: string;
  headline?: string;
  subhead?: string;
  noMargin?: boolean;
  cta?: {
    linkType?: string[];
    externalLink?: string;
    label?: string;
    page?: {
      node?: {
        uri?: string;
      };
    };
  };
  isRevealEnabled?: boolean;
  subheadReveal?: boolean;
  isInView?: boolean;
}

export default function SectionHeader(props: SectionHeaderProps) {
  const { headline, subhead, subheadReveal, eyebrow, largeTitle, noMargin, cta, isRevealEnabled = false, isInView = false } = props;
  const headlineMarkup = { __html: headline ? getHighlightMarkup(headline) : '' };
  const ctaData = getLinkData(cta);

  // -------------------- Render

  return (
    <div className={cx("section-header", { "no-margin": noMargin })}>
      { eyebrow && <p className={cx(["eyebrow", "eyebrow-l"])}>{eyebrow}</p> }
      <HeadlineAnim
        tag="h2"
        text={headlineMarkup.__html}
        className={cx(["title", { "title-uc-l": !largeTitle, "title-uc-xl": largeTitle }])}
        isRevealEnabled={isRevealEnabled}
        isInView={isInView}
      />
      { subhead && (
        <motion.div
          initial={ isRevealEnabled && subheadReveal ? { opacity: 0, y: 10 } : {} }
          animate={ isInView && isRevealEnabled && subheadReveal ? { opacity: 1, y: 0 } : {} }
          transition={{ duration: 0.5, delay: 0.3 }}
          className={cx("subhead", "text-m")}
          dangerouslySetInnerHTML={{ __html: subhead }}
        />
      )}
      { ctaData && <Button {...ctaData} />}
    </div>
  )
}